export default "__VITE_ASSET__Dz8VeC4H__"